module.exports = __webpack_public_path__ + "img/makeping-logo1.a709ada7.svg";